import React, { useState, useRef } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faWarehouse,
  faDna,
  faCalendarDays,
  faDove,
  faSkull,
  faEgg,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useShoppingContext } from "../../../context/ShoppingContext";

const MisAves = () => {
  const {
    aves,
    alimentos,
    fetchMisAves,
    calcularPorcentajePostura,
    getAveNombre,
    getGalponNombre, setIsSwipingAves,
  } = useShoppingContext();

  const [currentIndex, setCurrentIndex] = useState(0); // Controla el índice actual de la tarjeta
  const [touchStartX, setTouchStartX] = useState(0); // Coordenada inicial de toque
  const sliderRef = useRef(null); // Referencia para el contenedor del slider
  const maxCardsToShow = 1; // Mostrar solo una tarjeta a la vez
  const navigate = useNavigate();

  // Función para eliminar un ave
  const handleDelete = (id) => {
    if (window.confirm(`¿Seguro que quieres eliminar ${getAveNombre(id)}?`)) {
      axios
        .delete(`${process.env.REACT_APP_API_URL}/aves/${id}`)
        .then(() => fetchMisAves())
        .catch((error) => console.error("Error eliminando ave:", error));
    }
  };

  // Función para mover al siguiente ítem
  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === aves.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Función para mover al ítem anterior
  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? aves.length - 1 : prevIndex - 1
    );
  };

  // Manejar el inicio del deslizamiento (toque o mouse)
  const handleTouchStart = (e) => {
    setIsSwipingAves(true);
    setTouchStartX(e.touches ? e.touches[0].clientX : e.clientX); // Guardar la posición inicial del toque o mouse
  };

  // Manejar el final del deslizamiento (toque o mouse)
  const handleTouchEnd = (e) => {
    setIsSwipingAves(false);
    const touchEndX = e.changedTouches
      ? e.changedTouches[0].clientX
      : e.clientX;
    if (touchStartX - touchEndX > 50) {
      goToNext(); // Si se desliza a la izquierda, ir a la siguiente tarjeta
    } else if (touchStartX - touchEndX < -50) {
      goToPrevious(); // Si se desliza a la derecha, ir a la tarjeta anterior
    }
  };

    // Ordenar aves por edad de menor a mayor
    const sortedAves = [...aves].sort((a, b) => a.edad_actual - b.edad_actual);


  return (
    <div
      className="slider-container"
      ref={sliderRef}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleTouchStart}
      onMouseUp={handleTouchEnd}
    >
      <div
        className="slider"
        style={{
          width: `${aves.length * 100}%`, // El ancho del slider depende del número de tarjetas
          transform: `translateX(-${(currentIndex * 100) / aves.length}%)`, // Control de deslizamiento
        }}
      >
        {aves.length > 0 &&
          sortedAves.map((ave) => (
            <div
              key={ave.id}
              className="card"
              style={{ width: `${100 / maxCardsToShow}%` }}
            >
              <div className="card-header">
                <h2 className="card-title">{ave.nombre}</h2>
                <p className="especie">
                  <FontAwesomeIcon icon={faWarehouse} />{" "}
                  {getGalponNombre(ave.galponId)}
                </p>
                <p className="especie">
                  <FontAwesomeIcon icon={faDna} /> {ave.especie}
                </p>
                <p className="edad">
                  <FontAwesomeIcon icon={faCalendarDays} /> {ave.edad_actual}{" "}
                  semanas
                </p>
              </div>

              <div className="card-body">
                <p>
                  <strong>Comiendo:</strong> {ave.ingesta_diaria} kg.{" "}
                  {alimentos.find((alimento) => alimento.id === ave.id_alimento)
                    ?.nombre || "sin alimento"}
                </p>

                <div className="flex-space-between">
                  <p className="saldo">
                    <FontAwesomeIcon icon={faDove} /> {ave.saldo}
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faSkull} />{" "}
                    {((ave.mortalidad / ave.cantidad_inicial) * 100).toFixed(2)}
                    %
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faEgg} />{" "}
                    {calcularPorcentajePostura(ave.id) || 0}%
                  </p>
                </div>
              </div>

              <div className="card-footer">
                <button
                  className="btn btn-green"
                  onClick={() => navigate(`/edit-ave/${ave.id}`)}
                >
                  <FontAwesomeIcon icon={faEdit} /> Editar
                </button>
                <button
                  className="btn btn-green-outline"
                  onClick={() => handleDelete(ave.id)}
                >
                  <FontAwesomeIcon icon={faTrash} /> Eliminar
                </button>
              </div>
            </div>
          ))}
      </div>

      {/* Dots de navegación */}
      <div className="dots-container">
        {aves.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default MisAves;
